module.exports = "/_next/static/images/Aggregation@2x-e855911a74facc772e4035d624f7ac33.png";